import { render, staticRenderFns } from "./SchoolChangeTrend.vue?vue&type=template&id=00ef1899&scoped=true"
import script from "./SchoolChangeTrend.vue?vue&type=script&lang=js"
export * from "./SchoolChangeTrend.vue?vue&type=script&lang=js"
import style0 from "./SchoolChangeTrend.vue?vue&type=style&index=0&id=00ef1899&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ef1899",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00ef1899')) {
      api.createRecord('00ef1899', component.options)
    } else {
      api.reload('00ef1899', component.options)
    }
    module.hot.accept("./SchoolChangeTrend.vue?vue&type=template&id=00ef1899&scoped=true", function () {
      api.rerender('00ef1899', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/SchoolChangeTrend.vue"
export default component.exports